<template>
  <div>
    <h3 v-if='waitingUpload > 0' class="bg-gray-100 px-4 mb-3 text-3xl font-bold text-gray-700 shadow leading-relaxed tracking-wide border-b border-solid border-gray-500">
      Uploading...
    </h3>

    <h3 v-if='uploadedVideos.length' class="bg-gray-100 px-4 mb-3 text-3xl font-bold text-gray-600 shadow leading-relaxed tracking-wide border-b border-solid border-gray-500">
      Uploaded
    </h3>
    <video-gallery v-if='uploadedVideos.length'
                   :videos='uploadedVideos'
                   v-on='$listeners' />

    <vue-dropzone ref='dropzone'
                  :id="dropzoneId"
                  :options="dropzoneOptions"
                  :use-custom-slot="true"
                  @click.self='onRetry'
                  @vdropzone-processing='onProcessing'
                  @vdropzone-error='onError'
                  @vdropzone-removed-file='onRemovedFile'
                  @vdropzone-success='onSuccess'
                  >
                  <div class="dropzone-custom-content">
                    <h3 class="mb-3 font-bold text-xl text-gray-800">This is a public gallery.</h3>
                    <h3 class="text-2xl font-semibold text-gray-600">Tap here to upload a video!</h3>
                    <div class="leading-tight">...or drag and drop a video into the box.</div>
                  </div>
    </vue-dropzone>
    <div v-if='isError' class="-my-8">
      <div class="flex justify-center align-middle w-full">
        <!--
        <pbc-button @click='onRetry'>
          Retry
        </pbc-button>
        -->
        <pbc-button @click='onReset'>
          Reset
        </pbc-button>
      </div>
    </div>


    <loading v-if='waitingSigning > 0' />

  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import Loading from '@ui/atoms/Loading.vue';
import gql from 'graphql-tag';
import vueDropzone from 'nuxt-dropzone';
import VideoGallery from '@ui/molecules/VideoGallery.vue';
export default {
  inject:['api'],
  props: {
    gameId: {
      type: String,
      default: 'default',
    },
    // videos uploaded for this game already
    alreadyUploaded: {
      type: Array,
      default() {
        return [];
      }
    },
    userId: {
      type: String,
      default: 'anonymous'
    }
  },
  mounted() {
  },
  data() {
    const vm = this;
    const dropzoneOptions = {
      // The URL will be changed for each new file being processing
      url: '/',

      headers:{
        'Cache-Control':'public,max-age=31536000'
      },

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      thumbnailWidth: 80,
      thumbnailHeight: 80,

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      success: (file, bla) => {
        console.log('UPLOAD SUCCESS', file, bla);
        const {uploadURL} = file;
        const fileMetadata = this.metadata[uploadURL];
        console.log('filemetadata', fileMetadata);
        this.uploadedFiles.push(fileMetadata);
        this.$emit("uploaded", fileMetadata);

        setTimeout( () => {
          this.$refs.dropzone.dropzone.removeFile(file);
        }, 100);
      },

      // Here we request a signed upload URL when a file being accepted
      async accept(file, done) {
        vm.waitingUpload++;
        vm.waitingSigning++;
        try {
          console.log('accept', file);
          const {url,id,name} = await vm.getSignedUrl(file.name, file.type);
          const userId = vm.userId;
          vm.waitingSigning--;
          file.uploadURL = url
          vm.metadata[url] = {
            id,
            name,
            owner:userId
          }
          done()
          setTimeout(() => this.processFile(file))
        } catch (e) {
          vm.waitingSigning--;
          vm.waitingUpload--;
          console.error('failed getting signed url', e);
          done("Failed");
        }
      }
    }
    return {
      isError:false,
      isSuccess:false,
      busyUploading: false,
      uploadedFiles:cloneDeep(this.alreadyUploaded),
      metadata:{},
      errors:[],
      waitingSigning:0,
      waitingUpload:0,
      dropzoneOptions,
      batch:new Date().getTime(),
      getSignedUrlMutation: gql(`
        mutation getSignedVideoUploadUrl(
          $filename: String!
          $contentType: String!
          $gameId: String!,
          $batch: Long
        ) {
          getSignedVideoUploadUrl(
            filename: $filename
            contentType: $contentType
            gameId: $gameId,
            batch: $batch
          ) {
            id
            name
            url
          }
        }
      `)
    }
  },
  methods: {
    onSuccess(file) {
      this.isSuccess = true;
      console.log('success', file);
      this.waitingUpload--;
    },
    onError(file) {
      console.error('error', file);
      this.isError = true;
      this.errors.push(file);
    },
    onRetry() {
      this.isError = false;
      this.isSuccess = false;
      this.errors.forEach( (file) => {
        this.$refs.dropzone.dropzone.removeFile(file);
        this.$refs.dropzone.dropzone.enqueueFile(file);
      });
      this.errors = [];
    },
    onReset() {
      this.isError = false;
      this.isSuccess = false;
      this.errors = [];
      this.$refs.dropzone.removeAllFiles();
    },
    onRemovedFile(file) {
    },
    onProcessing(file) {
      this.$refs.dropzone.dropzone.options.url = file.uploadURL;
      this.dropzoneOptions.url = file.uploadURL;
    },
    async getSignedUrl(filename, contentType) {
      console.log('signing', filename, 'with', contentType);
      const {gameId, batch} = this;
      const data = await this.$apollo.mutate({
        mutation:this.getSignedUrlMutation,
        variables: {
          filename,
          contentType,
          gameId,
          batch
        }
      });
      console.log('have signed url data', data);
      return data.data.getSignedVideoUploadUrl;
    },
  },
  components: {
    vueDropzone,
    VideoGallery,
    Loading
  },
  computed: {
    dropzoneId() {
      return this.gameId + "-dropzone";
    },
    uploadedVideos() {
      return this.uploadedFiles.map( ({id, name, owner, ...img}) => {
        let url;
        if (img.url) {
          url = img.url;
        } else {
          url = this.api.makeVideoUrlEditor(id);
        }
        return {
          url,
          name,
          id,
          owner
        }
      });
    },
    myUploadedVideos() {
      return this.uploadedVideos.filter( ({owner}) => {
        return owner === this.userId;
      });
    },
  }
}
</script>
